/**
 * Prepare images c. elements of node for native lazy loading
 * @param {*} node parent node
 */
export const prepareImagesForNativeLazyLoading = (node: HTMLElement | Document) => {
  const images = node.querySelectorAll<HTMLImageElement>('img[loading="lazy"][data-src]');
  images.forEach((img) => {
    img.src = img.dataset.src || '';
    img.dataset.srcset ? (img.srcset = img.dataset.srcset) : null;
  });
};
